module.exports = __webpack_public_path__ + "media/assets/images/common/youtube-1320da148d389980e603c5baae7d18c2.png";